export default __webpack_public_path__ + "static/media/Car_Lora_ThumbAudiQ8.feae0ea8.jpg";